import type { ChatAttachment } from '@/stores/chat'
import type { ChatMessage } from '@/types/chat'

/** The i18n keys of the edits offered under a design chip, in the order shown. */
export const DESIGN_SUGGESTION_KEYS = ['bigger', 'dropRow', 'accent', 'moveUp', 'fit'] as const

/** Whether the design suggestions show: a design chip is attached, nothing is being answered, and the thread is empty or ends with Raldo's reply. */
export function showsDesignSuggestions(input: {
  attachment: Pick<ChatAttachment, 'kind'> | null
  messages: readonly Pick<ChatMessage, 'role'>[]
  busy: boolean
}): boolean {
  if (input.attachment?.kind !== 'design' || input.busy) return false
  const last = input.messages.filter((message) => message.role !== 'system').at(-1)
  return last === undefined || last.role === 'assistant'
}
